<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listservices" class="blue-grey-text text-darken-4 strong">Security Master</router-link>
        >
        <span>Add Service</span>
      </section>
    </article>
    <h4>Add Service</h4>
    <article class="row">
      <section class="input-field col s6">
        <input type="text"
               placeholder="e.g. Stock Advisor"
               class="validate"
               v-model="payload.name"
        >
        <label class="active">Name</label>
      </section>
      <section class="input-field col s6">
        <input type="number"
               placeholder=""
               class="validate"
               v-model="payload.product_id"
        >
        <label class="active">
          Product ID
          <span class="grey-text text-lighten-1">(Optional)</span>
        </label>
      </section>
    </article>
    <article class="row">
      <autocomplete
        v-if="benchmarks.length"
        id="add-service-benchmark-autocomplete"
        name="Benchmark"
        size="s4"
        watermark="e.g. S&P 500"
        :picks="benchmarks.map(b => `#${b.id} (${b.symbol}) ${b.name}`)"
        @picked="payload.benchmark_id = Number($event.slice(1, $event.indexOf(' ')))"
      />
      <autocomplete
        v-if="countries.length"
        id="add-service-country-autocomplete"
        name="Country"
        size="s4"
        watermark="e.g. United States"
        :picks="countries.map(c => `#${c.id} (${c.code}) ${c.name}`)"
        @picked="payload.country_id = Number($event.slice(1, $event.indexOf(' ')))"
      />
      <section class="input-field col s4">
        <select class="browser-default"
                v-model="payload.level"
        >
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
        </select>
        <label class="active">Level</label>
      </section>
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn waves-effect waves-light teal accent-4 right"
               type="submit"
               value="Submit"
               @click.prevent="saveService"
               v-if="$auth.hasRoles('admin')"
        >
        <input class="btn waves-effect waves-light teal accent-4 right"
               type="submit"
               value="Request"
               @click.prevent="sendServiceRequest"
               v-else
        >
      </section>
    </article>
    <notification-modal ref="ref-notification-modal" :message="notificationMessage" />
  </main>
</template>

<script>
import axios from 'axios';
import NotificationModal from '@/components/NotificationModal.vue';
import Autocomplete from '@/components/Autocomplete.vue';

const defaultPayload = {
  analyst_id: 0,
  name: '',
  product_id: null,
  benchmark_id: 0,
  country_id: 0,
  level: null,
};

export default {
  name: 'TickerAdminAddService',
  components: { NotificationModal, Autocomplete },
  props: {},
  data() {
    return {
      benchmarks: [],
      countries: [],
      payload: { ...defaultPayload },
      notificationMessage: '',
      validationErrorMessage: 'Please populate all required fields',
    };
  },
  watch: {},
  methods: {
    openNotificationModal() {
      const { modal } = this.$refs['ref-notification-modal'];
      modal.open();
    },
    resetForm() {
      this.payload.country_id = 0;
      this.payload.product_id = '';
      this.payload.benchmark_id = 0;
      this.payload.name = '';
      this.payload.level = 0;
      document.getElementById('add-service-benchmark-autocomplete').value = '';
      document.getElementById('add-service-country-autocomplete').value = '';
    },
    validateForm() {
      const usCountryId = 236;
      const requiredFields = [
        this.payload.analyst_id,
        this.payload.name,
        this.payload.benchmark_id,
        this.payload.country_id,
      ];

      /*
        A service level is only required for US services; levels do not currently apply to
        international services. We require it when a US service is being created or edited so we
        don't have to track down the level on our end.
      */
      if (this.payload.country_id === usCountryId) {
        requiredFields.push(this.payload.level);
      }

      return (requiredFields.every(arg => Boolean(arg)));
    },
    async fetchMetadata() {
      const promises = [
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/benchmarks/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/countries/`),
      ];
      const [benchmarksResp, countriesResp] = await Promise.all(promises);
      [this.benchmarks, this.countries] = [this.sortArray(benchmarksResp.data, 'name'), this.sortArray(countriesResp.data, 'name')];
    },
    async saveService() {
      this.payload.analyst_id = this.$auth.user.pk;
      this.payload.product_id = Number(this.payload.product_id) || null;
      if (!this.validateForm()) {
        return this.toast(this.validationErrorMessage, 'pink');
      }
      const { data } = await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/service/`, this.payload);
      this.notificationMessage = `Saved ${this.payload.name}. Service_id: ${data.service.id}`;
      this.openNotificationModal();
      this.payload = { ...defaultPayload };
      document.getElementById('add-service-benchmark-autocomplete').value = '';
      document.getElementById('add-service-country-autocomplete').value = '';
    },
    async sendServiceRequest() {
      this.payload.analyst_id = this.$auth.user.pk;
      this.payload.product_id = Number(this.payload.product_id) || null;
      if (!this.validateForm()) {
        const validationErrorMessage = 'Please populate all required fields';
        return this.toast(this.validationErrorMessage, 'pink');
      }
      let benchmarkName = '';
      this.benchmarks.forEach((benchmark) => {
        if (benchmark.id === this.payload.benchmark_id) {
          benchmarkName = benchmark.name;
        }
      });

      let countryName = '';
      this.countries.forEach((country) => {
        if (country.id === this.payload.country_id) {
          countryName = country.name;
        }
      });

      const userName = this.$auth.user.name;
      const serviceRequestMessage = `${userName} is requesting to add a Service:
        Name: ${this.payload.name}
        Product ID: ${this.payload.product_id}
        Benchmark: ${benchmarkName}
        Country: ${countryName}
        Level: ${this.payload.level}
      `;

      const payload = { message: serviceRequestMessage, channel: window.env.SLACK_HELP_CHANNEL };
      await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/common/slack/`, payload);
      const thankYouMessage = `Thanks! Your request to add the service: ${this.payload.name} has been submitted to the Investing Services team.`;
      this.notificationMessage = thankYouMessage;
      this.openNotificationModal();
      this.resetForm();
    },
  },
  mounted() {
    this.fetchMetadata();
  },
};
</script>
